module.exports = __webpack_public_path__ + "img/multi-h17.7aa72a07.gif";